import { AIAvatar } from '@repo/common/components/AI/Avatar';

export function AIAnimatedIllustration() {
	return <AIAvatar size="illustration" speed="slow" iconSpeed="none" />;
}
